import { contactCard } from '../../shared';

export const buyersAttorneyContactCard = contactCard(
  'additionalContacts.counterpartyAttorney',
  'counterpartyAttorney',
);
